module.exports = __webpack_public_path__ + "static/media/ergosunmeet2.2a8756af.mp4";